<!-- START: pages/page-404 -->
<div class="error-pages">
    <div class="container">
        <div class="row">
            <div class="col-md-12">
                <div class="error-header">
                    <img src="https://s.oab.org.br/imagens/marcas-sistemas/mono-negativa/2x/oab-seguranca.png" title="OAB Segurança">
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-md-5 text-center">
                <i class="fa fa-frown-o error-icon mt-2 mb-3"></i>
            </div>
            <div class=" col-md-7">
                <div class="error-msg">
                    <h3 class="mb-1">OOOPS!</h3>
                    <p class="mb-3">A página que você está procurando não pôde ser encontrada.</p>
                    <h2 class="mb-4">ERRO 404</h2>
                    <a href="#" class="btn btn-primary mb-5" title="Voltar"><i class="fa fa-arrow-circle-left mr-2"></i>Voltar</a>
                </div>
            </div>
        </div>
        <div class="row error-footer">
            <div class="col-md-12">
                <span class="push-right">Ordem dos Advogados do Brasil</span>
                <img class="img-fluid" src="https://s.oab.org.br/imagens/marcas-oab/oab/flat-positiva/2x/oab.png" title="Ordem dos Advogados Brasil">
            </div>
        </div>
    </div>
</div>